var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridViewToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_221991",
    "data-name": "Path 221991",
    d: "M10.8,2H3.1A1.039,1.039,0,0,0,2,3.1v7.7a1.039,1.039,0,0,0,1.1,1.1h7.7a1.039,1.039,0,0,0,1.1-1.1V3.1A1.039,1.039,0,0,0,10.8,2Zm0,12.1H3.1A1.039,1.039,0,0,0,2,15.2v7.7A1.039,1.039,0,0,0,3.1,24h7.7a1.039,1.039,0,0,0,1.1-1.1V15.2A1.039,1.039,0,0,0,10.8,14.1ZM22.9,2H15.2a1.039,1.039,0,0,0-1.1,1.1v7.7a1.039,1.039,0,0,0,1.1,1.1h7.7A1.039,1.039,0,0,0,24,10.8V3.1A1.039,1.039,0,0,0,22.9,2Zm0,12.1H15.2a1.039,1.039,0,0,0-1.1,1.1v7.7A1.039,1.039,0,0,0,15.2,24h7.7A1.039,1.039,0,0,0,24,22.9V15.2A1.039,1.039,0,0,0,22.9,14.1Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#fafafb",
    stroke: "#707070",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewToggle);
export default __webpack_public_path__ + "static/media/gridViewToggle.0efa8844d39416bc953fdf4abfd5ba27.svg";
export { ForwardRef as ReactComponent };